// extracted by mini-css-extract-plugin
export var box = "_o-2";
export var checkboxControl = "_o-0";
export var checkboxRow = "_o-a";
export var checked = "_o-3";
export var descriptionSpacer = "_o-c";
export var disabled = "_o-4";
export var icon = "_o-8";
export var input = "_o-1";
export var labelSpacer = "_o-b";
export var large = "_o-7";
export var medium = "_o-6";
export var small = "_o-5";
export var text = "_o-9";